import $ from "jquery";
//import "jquery-mobile";
import MobileDetect from '../js/mobile';
import 'jquery.appear';
import 'swiped-events';
import 'jquery.maskedinput/src/jquery.maskedinput';
//import 'jquery-touchswipe';

window.$ = window.jQuery = $;

class Main {

    Init = () => {
        const self = this;

        self.Forms();

        let padY = 0;
        if(MobileDetect.Init()){
            padY = 100;
        }

        $('.anchor').bind('click', function(e) {
            e.preventDefault();
            let href = $(this).attr('href');
            $("html, body").animate({ scrollTop: $(href).offset().top }, 1000);
        });

        $('.main-block, .item-leaf1, .item-leaf2').appear(function() {
            $(this).addClass('anim');
        },{accX: 0, accY: padY});





        if($('.main').length){
            self.MainAnimations();
        }
        if($('.main-block__img .hide').length){
           self.PartnersLogogAnim();
        }


        if($('.page').length){

            $('header, .page-in .title, .highlights__item, .location-block, .mab-block, .quickfacts__item, .anim-right, .anim-left, .anim-up, .anim-fade').appear(function() {
                $(this).addClass('anim');
            },{accX: 0, accY: padY});

            $('.title_leaf1, .title_leaf4, .title_leaf6, .title_leaf8, .t_leaf1, .t_leaf2, .anim_leaf').appear(function() {
                $(this).addClass('anim');
                setTimeout(function () {
                    $('.title_leaf1, .title_leaf4, .title_leaf6, .title_leaf8, .anim_leaf').addClass('anim_else');
                },2000);
                setTimeout(function () {
                    $('.t_leaf1, .t_leaf2').addClass('anim_else');
                },1000);
            },{accX: 0, accY: padY});

            $('.title_leaf2, .title_leaf3, .title_leaf5, .title_leaf7, .anim_leaf2').appear(function() {
                $(this).addClass('anim');
                setTimeout(function () {
                    $('.title_leaf2, .title_leaf3, .title_leaf5, .title_leaf7, .anim_leaf2').addClass('anim_else');
                },2500);
            },{accX: 0, accY: padY});



        }

        if(MobileDetect.Init()){
            $('.menu-item-with-sub > a').bind('click', function(e) {
                if(!$(this).hasClass('sub-noclick')){
                    e.preventDefault();
                    e.stopPropagation();
                    if($(window).width()<=1000){
                        $(this).parent().find('.submenu').toggleClass('open');
                    }
                }
            });
        }


        $('.mobmenu-icon').bind('click', function() {
            $('body').toggleClass('open-menu');
        });
        $('.footer__logo').bind('click', function() {
            $("html, body").animate({ scrollTop: 0 }, 1000);
        });


        document.addEventListener('click', function(e) {
            var t = $(e.target);
            if($(window).width()<=1000){
                if (t.closest('.mobmenu-icon').length === 0 && $('body').hasClass('open-menu') && t.closest('.menu').length === 0 && t.closest('.lang').length === 0) {
                    $('body').removeClass('open-menu');
                    $('header').scrollTop(0);
                }
            }
        });


        $( ".mobmenu" ).on( "swiped-right", function(){
            if($(window).width()<=1000){
                if ($('body').hasClass('open-menu')) {
                    $('body').removeClass('open-menu');
                    $('header').scrollTop(0);
                }
            }
        });

        /*
        $('.mobmenu').swipe({
            swipe:function(event, direction, distance, duration, fingerCount, fingerData) {
                if($(window).width()<=1000){
                    if ($('body').hasClass('open-menu') && direction === 'right') {
                        $('body').removeClass('open-menu');
                    }
                    if (direction == "down" || direction == "up"){
                        return false;
                    }
                    console.log(direction);
                }

            },
            threshold:20
        });

         */


        function add_mob_title(){
            $('.highlights__item__title').each(function () {
                if($(window).width()<=1000 && !$(this).parents('.highlights__item').find('.highlights__item__title-mob').length){
                    $(this).parents('.highlights__item').prepend('<div class="highlights__item__title highlights__item__title-mob">'+$(this).html()+'</div>')
                }
            });

            $('.quickfacts__title').each(function () {
                if($(window).width()<=1000 && !$(this).parents('.quickfacts__item').find('.quickfacts__title-mob').length && !$(this).parents('.quickfacts__item').hasClass('quickfacts__item-without-img')){
                    $(this).parents('.quickfacts__item').prepend('<div class="quickfacts__title quickfacts__title-mob">'+$(this).html()+'</div>')
                }
            });
        }

        add_mob_title();

        $(window).resize(function() {
            $('body').removeClass('open-menu');
            $('header').scrollTop(0);
            add_mob_title();
        });

        $(window).scroll(function() {
            if($(window).width()<=1000) {
                let scrolltop = $(window).scrollTop();
                let header = $('header');

                if (scrolltop > 100) {
                    header.addClass('fixed')
                } else {
                    header.removeClass('fixed')
                }
            }
        });
        $(window).trigger('scroll');

        if($('.block-404__digs').length){
            $('.block-404__digs, .block-404__text, .leaf404_1, .leaf404_2, .leaf404_3').addClass('anim');
            setTimeout(function () {
                $('.block-404__digs, .block-404__text, .leaf404_2, .leaf404_3').addClass('anim_else');
            },1500);
            setTimeout(function () {
                $('.leaf404_1').addClass('anim_else');
            },1900)

        }



    };
    PartnersLogogAnim = () => {
        setInterval(function () {
            $('.main-block__img').each(function () {
                if($(this).find('.hide').length){
                    let prev = $(this).find(':not(.hide)');
                    $(this).find('.hide').eq(0).removeClass('hide');
                    prev.addClass('hide');
                }
            });
        },2500);


    };
    MainAnimations = () => {
        $(window).scrollTop(0);

        let h_logo_top = $('.logo').offset().top;
        let h_logo_left = $('.logo').offset().left;

        let l_logo_top = $('.loader__logo').offset().top;
        let l_logo_left = $('.loader__logo').offset().left;

        let f_logo_top = l_logo_top - h_logo_top - 100;
        let f_logo_left = l_logo_left - h_logo_left;

        function disableScrolling(){
            let x=window.scrollX;
            let y=window.scrollY;
            window.onscroll=function(){window.scrollTo(x, y);};
        }

        function enableScrolling(){
            window.onscroll=function(){};
        }

        disableScrolling();


        $(document).ready(function(){
            let loader = $('.loader');
            let time_first_slide = 0;
            let logo_scale = '';
            if($(window).width()<=1000){
                logo_scale = ' scale(0.6)';
            }

            $('body').addClass('ready');


            setTimeout(function () {
                $('.loader__logo').css('transform', 'translate3d('+(-f_logo_left)+'px,'+(-f_logo_top)+'px,0)'+logo_scale);
                $('body').removeClass('load');
                enableScrolling();

            },2000);
            setTimeout(function () {
                $('.logo').html(loader.html());
                loader.remove();
            },3200);


            //show_main_slide2();
            if(loader.length){
                time_first_slide = 2000;
            }
            setTimeout(function () {
                show_main_slide1();
                change_main_slide();

                //show_main_slide2();
                //show_main_slide3();
            }, time_first_slide);

            //$('.anim').removeClass('anim');


        });

        function show_main_slide1() {
            $('.main__slide3, .main-photo3').addClass('hidden');
            $('.main__slide1, .main-photo1, .main-photo1 .main-photo__text > div:nth-child(1)').addClass('active');
            setTimeout(function () {
                $('.main-photo1 .main-photo__text > div:nth-child(1)').removeClass('active');
                $('.main-photo1 .main-photo__text > div:nth-child(2)').addClass('active');
            },3500);

            setTimeout(function () {
                $('.main__slide3, .main-photo3, .main-photo3 .main-photo__text > div').removeClass('active');
                $('.main__slide2, .main-photo2').removeClass('hidden');
            },2000);


            setTimeout(function () {
                $('.main__slide1 .leaf1 div').addClass('anim');
                $('.main__slide1 .leaf2 div').addClass('anim');
            },1800);
            setTimeout(function () {
                $('.main__slide1 .leaf3 div').addClass('anim');
                $('.main__slide1 .leaf4 div').addClass('anim');
                $('.main__slide1 .leaf5 div').addClass('anim');
                //change_main_slide();
            },2000);

        }

        function show_main_slide2() {
            $('.main__slide1, .main-photo1').addClass('hidden');
            $('.main__slide2, .main-photo2, .main-photo2 .main-photo__text > div:nth-child(1)').addClass('active');
            setTimeout(function () {
                $('.main-photo2 .main-photo__text > div:nth-child(1)').removeClass('active');
                $('.main-photo2 .main-photo__text > div:nth-child(2)').addClass('active');
            },3500);

            setTimeout(function () {
                $('.main__slide1, .main-photo1, .main-photo1 .main-photo__text > div').removeClass('active');
                $('.main__slide3, .main-photo3').removeClass('hidden');
            },2000);

            setTimeout(function () {
                $('.main__slide2 .leaf1').addClass('anim');
                $('.main__slide2 .leaf2 div').addClass('anim');
            },1800);
            setTimeout(function () {
                $('.main__slide2 .leaf3 div').addClass('anim');
                $('.main__slide2 .leaf4 div').addClass('anim');
                $('.main__slide2 .leaf5 div').addClass('anim');
            },2000);
        }

        function show_main_slide3() {
            $('.main__slide2, .main-photo2').addClass('hidden');
            $('.main__slide3, .main-photo3, .main-photo3 .main-photo__text > div:nth-child(1)').addClass('active');
            setTimeout(function () {
                $('.main-photo3 .main-photo__text > div:nth-child(1)').removeClass('active');
                $('.main-photo3 .main-photo__text > div:nth-child(2)').addClass('active');
            },3500);

            setTimeout(function () {
                $('.main__slide2, .main-photo2, .main-photo2 .main-photo__text > div').removeClass('active');
                $('.main__slide1, .main-photo1').removeClass('hidden');
            },2000);


            setTimeout(function () {
                $('.main__slide3 .leaf1').addClass('anim');
                $('.main__slide3 .leaf2 div').addClass('anim');
            },1800);
            setTimeout(function () {
                $('.main__slide3 .leaf3 div').addClass('anim');
                $('.main__slide3 .leaf4 div').addClass('anim');
                $('.main__slide3 .leaf5 div').addClass('anim');
            },2000);
        }

        let counter = 0;
        function change_main_slide() {

            setInterval(function () {
                counter++;
                if(counter === 1){
                    show_main_slide2();
                }else if(counter === 2){
                    show_main_slide3();
                }else if(counter === 3){
                    show_main_slide1();
                    counter = 0;
                }
            }, 9000);
        }





    };

    Forms = () => {

        function validateEmail(email) {
            let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }

        function validateForm(form) {
            let check = true;
            //form.find('.input').removeClass('error');

            form.find('.req:visible').each(function() {
                if($(this).find('input').val()==''){
                    $(this).addClass('error');
                    check = false;
                }else if($(this).find('input[type=checkbox]').length && !$(this).find('input:checked').length) {
                    $(this).addClass('error');
                    check = false;

                }else if($(this).find('textarea').val()=='') {
                    $(this).addClass('error');
                    check = false;
                }else{
                    if(($(this).find('input').length && $(this).find('input').val().replace(/\s/g, '')==='') || ($(this).find('textarea').length && $(this).find('textarea').val().replace(/\s/g, '')==='')){
                        $(this).addClass('error');
                        check = false;
                    }else{
                        $(this).removeClass('error')
                    }
                }

                /*
                if($(this).find('textarea').val()===''){
                    $(this).addClass('error');
                    check = false;
                }else{
                    $(this).removeClass('error')
                }

                 */


            });
            if(form.find('.email').hasClass('req') || form.find('.email').find('input').val().length){
                if(!validateEmail(form.find('.email').find('input').val())){
                    form.find('.email').addClass('error');
                    check = false;
                }else{
                    form.find('.email').removeClass('error');
                }
            }else{
                form.find('.email').removeClass('error');
            }
            return check;
        }

        function validateInput(input_in){
            let parent = input_in.parent('.input');
            if(parent.hasClass('error')){
                if(parent.hasClass('req') && input_in.val()!==''){
                    if(parent.hasClass('email')){
                        if(validateEmail(input_in.val())){
                            parent.removeClass('error');
                        }
                    }else{
                        parent.removeClass('error');
                    }
                }
            }
        }

        function getFormData(f){
            let unindexed_array = f.serializeArray();
            let indexed_array = {};
            $.map(unindexed_array, function(n, i) {
                let name = n['name'];
                let value = n['value'];
                if (name.indexOf('[]') != -1) {
                    if (!indexed_array[name]) {
                        indexed_array[name] = [];
                    }
                    indexed_array[name].push(value);
                }
                else {
                    indexed_array[name] = value;
                }
            });
            return indexed_array;
        }

        $('form .phone input').mask('+7(999) 999-9999', {autoclear: true});

        $('form input, form textarea').bind('change input paste', function() {
            validateInput($(this));
        });

        $('form input[name="contact"]').bind('change', function() {
            let val = $(this).val();
            let form = $(this).parents('form');
            console.log(val);

            if(val == 'email'){
                form.find('.phone').removeClass('error');
                form.find('.phone').removeClass('req');
                form.find('.email').addClass('req');
            }else{
                form.find('.email').removeClass('error');
                form.find('.email').removeClass('req');
                form.find('.phone').addClass('req');
            }
        });



        $('form').bind('submit', function(e) {
            let f = $(this);
            if (!validateForm(f)) {
                e.preventDefault();
                f.find('.error').eq(0).focus();
                return false;
            }
            let url = f.attr('action');

            if(!f.find('input[name="asc"]').length){
                f.append('<input hidden type="text" name="asc" value="'+$('body').attr('rel')+'">')
            }
            let data = getFormData(f);
            $.post(url, data, function(response) {
                console.log(response);
                response = $.parseJSON(response);
                if (response.error) {
                    f.parent().find('.form-result').removeClass('none');
                    f.addClass('none');
                    f.parent().find('.form-result__error').removeClass('none');
                }
                else {
                    f.parent().find('.form-result').removeClass('none');
                    f.addClass('none');
                    f.parent().find('.form-result__success').removeClass('none');
                    f.find('input[type="text"], textarea').val('');
                }

            }).fail(function() {
                f.parent().find('.form-result').removeClass('none');
                f.addClass('none');
                f.parent().find('.form-result__error').removeClass('none');

            });
            e.preventDefault();
            return false;
        });





    };



}


export default new Main;
